import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 tenant_delete_restricted_number_settings: { message: "idle" },
};

export const tenant_delete_restricted_number_settings_Slice = createSlice({
 name: "tenant_delete_restricted_number_settings",
 initialState,
 reducers: {
  success_tenant_delete_restricted_number_settings: (state, action) => {
   state.tenant_delete_restricted_number_settings = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_tenant_delete_restricted_number_settings: (state, action) => {
   state.tenant_delete_restricted_number_settings = { status: app_consts.FAIL, message: action.payload };
  },
  reset_tenant_delete_restricted_number_settings: (state) => {
   state.tenant_delete_restricted_number_settings = { status: app_consts.IDLE };
  },
  loading_tenant_delete_restricted_number_settings: (state) => {
   state.tenant_delete_restricted_number_settings = { status: app_consts.LOADING };
  },
 }
});

export const { success_tenant_delete_restricted_number_settings, fail_tenant_delete_restricted_number_settings, reset_tenant_delete_restricted_number_settings, loading_tenant_delete_restricted_number_settings } = tenant_delete_restricted_number_settings_Slice.actions;

export default tenant_delete_restricted_number_settings_Slice.reducer;